import enLocale from "../../../locales/en.json";
import frLocale from "../../../locales/fr.json";
import esLocale from "../../../locales/es.json";
import itLocale from "../../../locales/it.json";
import trLocale from "../../../locales/tr.json";
import arLocale from "../../../locales/ar.json";
import deLocale from "../../../locales/de.json";

export const supportedLangs = ["en", "fr", "es", "it", "tr", "ar", "de"] as const;
export type Lang = (typeof supportedLangs)[number];
export const defaultLang: Lang = "en";

const locales: Record<Lang, Record<string, unknown>> = {
  en: enLocale as unknown as Record<string, unknown>,
  fr: frLocale as unknown as Record<string, unknown>,
  es: esLocale as unknown as Record<string, unknown>,
  it: itLocale as unknown as Record<string, unknown>,
  tr: trLocale as unknown as Record<string, unknown>,
  ar: arLocale as unknown as Record<string, unknown>,
  de: deLocale as unknown as Record<string, unknown>,
};

export function loadLocale(lang: Lang): Record<string, unknown> {
  return locales[lang] || locales[defaultLang];
}

export function getDir(lang: Lang): "rtl" | "ltr" {
  return lang === "ar" ? "rtl" : "ltr";
}

export function getNestedValue(obj: Record<string, unknown>, path: string): string {
  const keys = path.split(".");
  let current: unknown = obj;
  for (const key of keys) {
    if (current && typeof current === "object" && key in (current as Record<string, unknown>)) {
      current = (current as Record<string, unknown>)[key];
    } else {
      return path;
    }
  }
  return typeof current === "string" ? current : path;
}

export function getNestedArray(obj: Record<string, unknown>, path: string): string[] {
  const keys = path.split(".");
  let current: unknown = obj;
  for (const key of keys) {
    if (current && typeof current === "object" && key in (current as Record<string, unknown>)) {
      current = (current as Record<string, unknown>)[key];
    } else {
      return [];
    }
  }
  return Array.isArray(current) ? current.map(String) : [];
}

export const langLabels: Record<Lang, string> = {
  en: "English",
  fr: "Français",
  es: "Español",
  it: "Italiano",
  tr: "Türkçe",
  ar: "العربية",
  de: "Deutsch",
};
